import { Navigate } from "react-router-dom"

import { provideComponent, useData } from "scrivito"
import { NOT_FOUND } from "shared/constants/permalinks"

import { useNavigateToPermalink } from "features/navigation/model/useNavigateToPermalink"
import { ProjectPageConnector } from "pages/project-page/ProjectPageConnector"
import { ProjectPageLoader } from "pages/project-page/ProjectPageLoader"

import { ProjectPageObjClass } from "./ProjectPageObjClass"

provideComponent(
  ProjectPageObjClass,
  ({ page }) => {
    const data = useData()
    const projectID = data.isDataItem()
      ? (data.dataItem()?.get("id") as string)
      : null

    const { href } = useNavigateToPermalink(NOT_FOUND)

    if (!projectID) {
      return <Navigate to={href} />
    }

    return (
      <ProjectPageConnector key={projectID} projectID={projectID} page={page} />
    )
  },
  {
    loading: () => <ProjectPageLoader />
  }
)
